import React, { useCallback, useMemo, useEffect } from 'react';
import { useStore } from '../../store';
import { useNavigate, useParams, Link } from 'react-router-dom';
import DataSheetInput from '../Inputs/DatasheetInput';
import { createRecordCopy } from '../../Utils/Functions/helpers';
import SRFButton from '../Inputs/SRFButton/SRFButton';

function List() {
  const { isAuthed, translation } = useStore();
  const { type } = useParams();
  const navigate = useNavigate();

  const ViewColumn = useMemo(() => ({
    component: ({ rowData, deleteRow }) => (
      <div className='w-full h-full flex justify-center'>
        <button
          type='button'
          className='text-center w-full h-full'
          onClick={() => navigate(`/form/${btoa(rowData.recordId)}`)}
        >
          {translation.view}
        </button>
        {type === "drafts" ? (
          <button
            type='button'
            className='text-center w-4/5 h-full border-l border-gray-300'
            onClick={() => {
              deleteRow();
            }}
          >
            ❌
          </button>
        ) : null}
         {type === "history" ? (
          <button
            type='button'
            className='text-center w-4/5 h-full border-l border-gray-300'
            onClick={async () => {
              const newKey = await createRecordCopy(rowData.recordId);
              navigate(`/form/${btoa(newKey)}`);
            }}
          >
            Copy
          </button>
        ) : null}
      </div>
    ),
    basis: ["drafts", "history"].includes(type) ? 100 : 60
  }), [type, translation, navigate]);

  useEffect(() => {
    if (!isAuthed) {
      navigate("/auth");
    }
  }, [isAuthed, navigate]);

  const dfrFilter = useCallback(
    (dfr) =>
      type !== "history"
        ? dfr?.recordId < 0 &&
        (type === "pending" ? dfr?.submitted : !dfr?.submitted)
        : dfr.recordId > 0,
    [type]
  );

  const dfrDefault = useMemo(() => {
    return {};
  }, []);

  const dfrColumns = useMemo(
    () => [
      ["date", { title: translation.date, isCellEmpty: () => false, disabled: () => true }],
      ["jobNumber", { title: translation.jobNumber, isCellEmpty: () => false, disabled: () => true }],
      ["notes", { title: translation.summaryOfWorkCompleted, isCellEmpty: () => false, disabled: () => true }]
    ],
    [translation]
  );

  return (
    <div className='flex flex-col items-center py-4 gap-6'>
      <div className='lg:w-1/3 md:w-1/2 w-full px-4'>
        <Link to="/">
          <SRFButton color='#0f314d'>{translation.home}</SRFButton>
        </Link>
      </div>
      <div className='lg:w-3/4 w-full px-4'>
        <DataSheetInput
          tableName={"dailyFieldReports"}
          filter={dfrFilter}
          defaultValues={dfrDefault}
          columns={dfrColumns}
          label={translation[type]}
          stickyRightColumn={ViewColumn}
          height={window.innerHeight - 400}
          addRowsComponent={false}
        />
      </div>
    </div>
  );
}

export default List;
